<template>
  <div>
      <div v-if="isLogin">
          <div style="position: absolute;top:0px;left:40px;">
            <a  class="name"><b>{{title }}</b></a>
          </div>
          <a-menu  v-model:selectedKeys="current" mode="horizontal" style="padding-left:105px">
            <a-menu-item @click="to('/index')" key="index">
                  <template #icon>
                    <home-outlined />
                  </template>首页
              </a-menu-item>
              <a-menu-item  v-if="isTop=='true'" @click="to('/agent')"  key="agent">
                  <template #icon>
                        <solution-outlined />
                  </template>
                  代理
              </a-menu-item>
              <a-sub-menu key="memberManager">
                  <template #icon>
                      <shop-outlined />
                  </template>
                  <template #title>商家</template>
                  <a-menu-item @click="to('/member')" key="member">用户列表</a-menu-item>
                  <a-menu-item @click="to('/shop')" key="shop">店铺列表</a-menu-item>
                  <a-menu-item @click="to('/goods')" key="goods">商品管理</a-menu-item>
                  <a-menu-item @click="to('/memberRefund')" key="memberRefund">未返款商家</a-menu-item>

              </a-sub-menu>

              <a-sub-menu key="taskManager">
                  <template #icon>
                      <flag-outlined />
                  </template>
                  <template #title>计划</template>
                  <a-menu-item @click="to('/task')" key="task">计划列表</a-menu-item>
                  <a-menu-item @click="to('/plan')" key="plan">计划看板</a-menu-item>
              </a-sub-menu>

              <a-sub-menu key="orderManager">
                  <template #icon>
                      <profile-outlined />
                  </template>
                  <template #title>任务</template>
                  <a-menu-item @click="to('/order')" key="order">进行中</a-menu-item>
                  <a-menu-item @click="to('/okOrder')" key="okOrder">已完成</a-menu-item>
                  <a-menu-item @click="to('/praiseOrder')" key="praiseOrder">评价管理</a-menu-item>
              </a-sub-menu>

              <a-sub-menu key="undo">
                <template #icon>
                    <exception-outlined />
                  </template>
                  <template #title>售后</template>
                  <a-menu-item @click="to('/undo')" key="undoProcess">进行中</a-menu-item>
                  <a-menu-item @click="to('/undoOk')" key="undoOk">已完成</a-menu-item>
              </a-sub-menu>



              <a-menu-item @click="to('/recharge')" key="recharge" >
                <template #icon>
                    <credit-card-outlined />
                </template>
                充值
            </a-menu-item>
 


            <a-sub-menu key="payManager">
                  <template #icon>
                      <alipay-outlined />
                  </template>
                  <template #title>付款</template>
                  <a-menu-item @click="to('/pay')" key="pay">进行中</a-menu-item>
                  <a-menu-item @click="to('/okPay')" key="okPay">已完成</a-menu-item>
                  <a-menu-item  v-if="isTop=='true'" @click="to('/cashierFundsStatistics')" key="cashierFundsStatistics">任务看板</a-menu-item>

              </a-sub-menu>

              <a-menu-item @click="to('/download')" key="download">
                  <template #icon>
                    <download-outlined />
                  </template>
                  报表下载
              </a-menu-item>
            


              <a-menu-item @click="to('/agentRecord')" key="agentRecord">
                  <template #icon>
                    <file-search-outlined />
                  </template>资金流水
              </a-menu-item>

              <a-menu-item @click="to('/agentPanel')" key="agentPanel">
                  <template #icon>
                    <pay-circle-outlined />
                  </template>日报
              </a-menu-item>
              
              <a-menu-item @click="to('/commission')" key="commission">
                  <template #icon>
                    <setting-outlined />
                  </template>佣金模板
              </a-menu-item>
              <a-menu-item v-if="isTop=='true'" @click="to('/leader')" key="leader">
                  <template #icon>
                    <TeamOutlined />
                  </template>人员管理
              </a-menu-item>

          </a-menu>
          <div style="position: absolute;top:0px;right:20px;line-height: 48px;">
            <a-dropdown>
                <a class="ant-dropdown-link" @click.prevent style="font-size:14px;letter-spacing:1px">
                    {{name}}
                    <DownOutlined />
                </a>
                <template #overlay>
                <a-menu>
                  <a-menu-item>
                        <a @click="setPwd" href="javascript:;">修改密码</a>
                    </a-menu-item>
                    <a-menu-item>
                        <a @click="logout" href="javascript:;">退出登陆</a>
                    </a-menu-item>
                </a-menu>
                </template>
            </a-dropdown>

            <!-- <a style="margin-right:20px"><user-outlined />{{name}}</a>
            <a-button type="danger" size="small" shape="circle">
              
            </a-button> -->
          </div>
      </div>
      <a-config-provider :locale="zhCN">
            <router-view />
      </a-config-provider>   

        <a-modal :confirmLoading="operateing"  v-model:visible="visible" style="width:400px" cancelText="取消" okText="确定"  title="修改密码" @ok="handleOk">
          <a-form
          ref="formRef"
          name="refForm"
            :model="model"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 18 }"
            autocomplete="off"
          >
            <a-form-item
              label="原密码"
              name="oldPwd"
              :rules="[{ required: true, message: '请输入原密码' }]"
            >
              <a-input-password  v-model:value="model.oldPwd" />
            </a-form-item>
            <a-form-item
              label="新密码"
              name="newPwd"
              :rules="[{ required: true, message: '请输入新密码' }]"
            >
              <a-input-password  v-model:value="model.newPwd" />
            </a-form-item>
            <a-form-item
              label="确认密码"
              name="newPwdConfrim"
              :rules="[{ required: true, message: '请确认新密码' }]"
            >
              <a-input-password  v-model:value="model.newPwdConfrim" />
            </a-form-item>
          </a-form>
        </a-modal>
  </div>
</template>
<script>


import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs"
import "dayjs/locale/zh-cn"
dayjs.locale("zh-cn")

import { agentSetPassWordReq} from '@/request.js';
import { message } from 'ant-design-vue';
import {config} from './config'

import { defineComponent, ref,watch } from 'vue';
import { useRouter } from 'vue-router';
import { ShopOutlined,FlagOutlined,ProfileOutlined,PayCircleOutlined,SettingOutlined,DownOutlined,DownloadOutlined,HomeOutlined,SolutionOutlined,
  CreditCardOutlined,AlipayOutlined,FileSearchOutlined,ExceptionOutlined,TeamOutlined} from '@ant-design/icons-vue';
export default defineComponent({
  components: {
      ShopOutlined,FlagOutlined,ProfileOutlined,PayCircleOutlined,SettingOutlined,DownOutlined,DownloadOutlined,HomeOutlined,SolutionOutlined,CreditCardOutlined,FileSearchOutlined ,ExceptionOutlined,
      AlipayOutlined,TeamOutlined
  },
  setup() {
    const model=ref(
      {
        oldPwd:"",
        newPwd:"",
        newPwdConfrim:""
      }
    )
    const title=ref(config.title);
    const operateing=ref(false);
    const formRef=ref();
    const visible=ref(false);
    const isTop=ref(false);
    const isLogin=ref(false);
    const name=ref("");
    isLogin.value=localStorage.getItem("token")!=null;
    isTop.value=localStorage.getItem("isTop");


    const router=useRouter();
    if(!isLogin.value){
      router.push({path:'/login'})
    }else{
      name.value=localStorage.getItem("name");
    }
    const current = ref([]);
    let array=window.location.href.split('#');
    if(array.length>1){
        if(array[1]=='/'){
            current.value=["index"];
        }else{
            current.value=[array[1].replace('/','')];
        }
    }
    watch(() => router.currentRoute.value.path,(newValue) => {
      if(newValue=="/index"){
        isLogin.value=localStorage.getItem("token")!=null;
        isTop.value=localStorage.getItem("isTop");
        name.value=localStorage.getItem("name");
      }
  },{ immediate: true });
 
  const handleOk=()=>{
    formRef.value
            .validate()
            .then(() => {
              if(model.value.newPwd==model.value.newPwdConfrim){
                operateing.value=true;
                agentSetPassWordReq({oldPwd:model.value.oldPwd,newPwd:model.value.newPwd},(res)=>{
                  if(res.IsSuccess){
                    message.success("修改成功");
                    visible.value=false;
                  }else{
                    message.error("原密码不正确");
                  }
                  operateing.value=false
                });
              }else{
                message.error("两次输入密码不一致");
              }
            })
            .catch(() => {
            });
  }
    const to=(path)=>{
        router.push({path:path})
    }
    const logout=()=>{
        localStorage.removeItem("name");
        localStorage.removeItem("token")
        router.push({path:"/login"})
    }
    const setPwd=()=>{
      visible.value=true;
    }
    return {
      title,
      operateing,
      formRef,
      model,
      handleOk,
      visible,
      setPwd,
      isTop,
        logout,
        zhCN,
        to,
        current,
        isLogin,
        name
    };
  },
});
</script>
<style>
.ant-drawer-body{
    padding:0px
}
</style>
<style scoped>
.name{
  line-height: 46px;
  text-decoration: underline;
  color:#0d0c22;
  text-decoration:none; 
  font-size: 22px;
  letter-spacing:2px;
}
.name:disabled{
  color:#0d0c22;
}
</style>